import { render, staticRenderFns } from "./ServiceAnalyticsSubjectCardDetails.vue?vue&type=template&id=25204849&"
import script from "./ServiceAnalyticsSubjectCardDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceAnalyticsSubjectCardDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports